<template>
  <div>
    <!-- <Menu/> -->
    <Imgs/>
  </div>
</template>

<script>
import Menu from './LunboMenu'
import Imgs from './LunboImgs'

export default {
  name: 'index',
  components: {
    Menu,
    Imgs
  }
}
</script>

<style>

</style>